export const OrderCI_ORDERDETAIL_STATE_PATH = 'orderDetail';

export class OrderDetailModel {
	id: number;
	documentId: string;
	formType?: string;
	schema: string;
	state?: number;
	stateEnum: string;
	revised: boolean;
	description?: string;
	deleted?: boolean;
	externalId?: string;
	externalLoanNumber?: string;
	externalLoanType?: string;
	externalProvider?: string;
	externalTrackingProvider?: string;
	externalProductName?: string;
	locked?: Date;
	lockedBy?: OrderLockedBy;
	isCMPForm?: boolean;
	guaranteeState?: number;
	guaranteeStateDescription?: string;
	smartQCState?: number;
	pipelineIndicators?: Array<PipelineObject>;
	cuScore?: number;
	lcaScore?: number;
	canSubmitEAD?: boolean;
	canSubmitUCDP?: boolean;
	docFileIdEAD?: string;
	docFileIdUCDP?: string;
	requestedAction?: string;
	isWorkable?: boolean;
	envExportEnabled?: boolean;
	envErrorMessage?: string;
	envStatus?: number;

	constructor() {
		this.documentId = '';
		this.formType = undefined;
		this.schema = '';
		this.state = undefined;
		this.stateEnum = '';
		this.revised = false;
		this.description = undefined;
		this.deleted = undefined;
		this.externalId = undefined;
		this.externalLoanNumber = undefined;
		this.externalLoanType = undefined;
		this.externalProvider = undefined;
		this.externalTrackingProvider = undefined;
		this.locked = undefined;
		this.lockedBy = new OrderLockedBy();
		this.pipelineIndicators = [];
		this.guaranteeState = 0;
		this.guaranteeStateDescription = '';
		this.cuScore = 0;
		this.lcaScore = 0;
		this.canSubmitEAD = false;
		this.canSubmitUCDP = false;
		this.requestedAction = '';
	}
}

export interface PipelineObject {
	created: string;
	key: string;
	message: string;
	label: string;
	description: string;
	enabled: true;
	color: string;
}

export class OrderLockedBy {
	firstName: string | null;
	id: string | null;
	lastName: string | null;

	constructor() {
		this.firstName = null;
		this.id = null;
		this.lastName = null;
	}
}
